module.exports = __webpack_public_path__ + "media/spin.3096597c.wav";